import { customReq } from "./networkService";

export default {
  getPublicBadge(badgeId: string) {
    const call = {
      method: "get",
      url: "/api/v1/badges/" + badgeId,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return customReq(call);
  },

  getBadgesList(
    param: string = "campaign",
    searchValue: string = "",
    page: number = 1,
    size: number = 10
  ) {
    const call = {
      method: "get",
      url: `/admin/v1/badges?${param}=${searchValue}&page=${page}&size=${size}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return customReq(call);
  },

  deleteBadge(badgeId: string) {
    const call = {
      method: "delete",
      url: "/admin/v1/badges/" + badgeId,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return customReq(call);
  },

  createBadges(campaignName: string, file: File) {
    const formData = new FormData();
    const blobFile = new Blob([file], { type: "application/x-pkcs12" });
    formData.append("excel", blobFile);
    formData.append("campaign", campaignName || "");

    const call = {
      method: "post",
      url: "/admin/v1/badges",
      headers: {},
      body: formData,
    };

    return customReq(call);
  },
  logout() {
    const call = {
      method: "delete",
      url: "/admin/v1/logout",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return customReq(call);
  },

  authToken(token: string) {
    const call = {
      url: "/token",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return customReq(call);
  },

  getAuthData() {
    const call = {
      url: "/admin/v1/auth",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    return customReq(call);
  },
};
